document.querySelectorAll('[data-contact]').forEach((contact) => {

  const targetParent = contact.querySelector('[data-contact-hover]');
  const target = contact.querySelector('[data-contact-hover-target]');


  const triggers = contact.querySelectorAll('[data-title-hover]');

  triggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', () => {
      targetParent.classList.add('active');
      target.innerText = trigger.getAttribute('data-title-hover');
    })

    trigger.addEventListener('mouseleave', () => {
      targetParent.classList.remove('active');
      target.innerText = '';
    })
  })

})
